// extracted by mini-css-extract-plugin
module.exports = {"row":"RealizedDialog_row__1Dwr1","row_small":"RealizedDialog_row_small__35dI9","container":"RealizedDialog_container__3Fp-T","icon":"RealizedDialog_icon__3hcXW"};